import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "vac-message-files-container" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "vac-svg-button" }
const _hoisted_4 = { class: "vac-text-ellipsis" }
const _hoisted_5 = {
  key: 0,
  class: "vac-text-ellipsis vac-text-extension"
}

import SvgIcon from "vue-advanced-chat/src/components/SvgIcon/SvgIcon.vue";
import FormatMessage from "vue-advanced-chat/src/components/FormatMessage/FormatMessage.vue";
import ProgressBar from "vue-advanced-chat/src/components/ProgressBar/ProgressBar.vue";

// import MessageFile from "vue-advanced-chat/src/lib/Room/RoomMessage/MessageFiles/MessageFile/MessageFile.vue";
import MessageFile from "./MessageFile.vue";
import {
	Message,
	MessageFile as IMessageFile,
	TextFormatting,
} from "vue-advanced-chat";

import { isImageVideoFile } from "vue-advanced-chat/src/utils/media-file.js";
import { computed } from "vue";

type MessagesFileProps = {
	currentUserId: string | number;
	message: Message;
	roomUsers: unknown[];
	textFormatting?: TextFormatting;
	linkOptions?: {
		disabled: false;
		target: string;
		rel: unknown;
	};
	messageSelectionEnabled: boolean;
};

export default /*#__PURE__*/_defineComponent({
  props: {
    currentUserId: null,
    message: null,
    roomUsers: null,
    textFormatting: { default: () => ({
		disabled: false,
		italic: "_",
		bold: "*",
		strike: "~",
		underline: "°",
		multilineCode: "```",
		inlineCode: "`",
	}) },
    linkOptions: { default: () => ({ disabled: false, target: "_blank", rel: null }) },
    messageSelectionEnabled: { type: Boolean }
  },
  emits: ["open-file", "download-file", "open-user-tag"],
  setup(__props: any, { emit }: { emit: ({
	(e: "open-file", value: { file: IMessageFile; action: string }): void;
	(e: "download-file", value: { file: IMessageFile; action: string }): void;
	(e: "open-user-tag", value: unknown): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { currentUserId: string | number, message: Message, roomUsers: unknown[], textFormatting: TextFormatting, linkOptions: {
		disabled: false;
		target: string;
		rel: unknown;
	}, messageSelectionEnabled: boolean }




const imageVideoFiles = computed(() => {
	return props.message.files?.filter(f => isImageVideoFile(f));
});
const otherFiles = computed(() => {
	return props.message.files?.filter(f => !isImageVideoFile(f));
});

function openFile(event: Event, file: IMessageFile, action: string) {
	if (!props.messageSelectionEnabled) {
		event.stopPropagation();
		emit("open-file", { file, action });
	}
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(imageVideoFiles), (file, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx + 'iv'
      }, [
        _createVNode(MessageFile, {
          file: file,
          "current-user-id": __props.currentUserId,
          message: __props.message,
          index: idx,
          "message-selection-enabled": __props.messageSelectionEnabled,
          onOpenFile: _cache[0] || (_cache[0] = ($event: any) => (emit('open-file', $event))),
          onDownloadFile: _cache[1] || (_cache[1] = ($event: any) => (emit('download-file', $event)))
        }, _createSlots({ _: 2 }, [
          _renderList(_ctx.$slots, (i, name) => {
            return {
              name: name,
              fn: _withCtx((data) => [
                _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(data)))
              ])
            }
          })
        ]), 1032, ["file", "current-user-id", "message", "index", "message-selection-enabled"])
      ]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(otherFiles), (file, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        key: idx + 'a',
        class: "vac-file-wrapper"
      }, [
        (file.progress && file.progress >= 0)
          ? (_openBlock(), _createBlock(ProgressBar, {
              key: 0,
              progress: file.progress,
              style: { top: '44px' }
            }, null, 8, ["progress"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["vac-file-container", {
					'vac-file-container-progress': file.progress && file.progress >= 0,
				}]),
          onClick: ($event: any) => (openFile($event, file, 'download'))
        }, [
          _createElementVNode("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "document-icon", {}, () => [
              _createVNode(SvgIcon, { name: "document" })
            ])
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(file.name), 1),
          (file.extension)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(file.extension), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_2)
      ]))
    }), 128)),
    _createVNode(FormatMessage, {
      content: __props.message.content,
      users: __props.roomUsers,
      "text-formatting": __props.textFormatting,
      "link-options": __props.linkOptions,
      onOpenUserTag: _cache[2] || (_cache[2] = ($event: any) => (emit('open-user-tag', undefined)))
    }, _createSlots({ _: 2 }, [
      _renderList(_ctx.$slots, (i, name) => {
        return {
          name: name,
          fn: _withCtx((data) => [
            _renderSlot(_ctx.$slots, name, _normalizeProps(_guardReactiveProps(data)))
          ])
        }
      })
    ]), 1032, ["content", "users", "text-formatting", "link-options"])
  ]))
}
}

})